import { useRef, useEffect } from 'react';

import { Label } from '@hivebrite/design-system/Label';
import { usePrevious } from '@hivebrite/react-hooks';

import InputLocation from 'hb-react/frontoffice/components/inputs/InputLocation';
import type { Location } from 'hb-react/types';

interface LocationSearchProps {
  id: string;
  value: Location;
  onChange: (value: Location) => void;
}

const LocationSearch = ({ id, value, onChange }: LocationSearchProps) => {
  const componentRef = useRef(null);

  const prevValue = usePrevious(value);

  useEffect(() => {
    const hasValue = (val?: Location) => val?.location;

    if (hasValue(prevValue) && !hasValue(value)) {
      // @ts-expect-error untyped component InputLocation
      componentRef.current?.resetLocationState();
    }
  }, [prevValue, value]);

  return (
    <>
      <Label id={id}>{s__('Mentoring|Location')}</Label>
      <InputLocation
        // @ts-expect-error untyped component
        inputName="location"
        id={id}
        placeholder={__('Type and select a location')}
        defaultLocation={{ ...value, address: value?.location }}
        onSelectLocation={onChange}
        componentRef={(ref) => (componentRef.current = ref)}
      />
    </>
  );
};

export default LocationSearch;
